import { render, staticRenderFns } from "./MatchResultModal.vue?vue&type=template&id=34194078&scoped=true&"
import script from "./MatchResultModal.vue?vue&type=script&lang=js&"
export * from "./MatchResultModal.vue?vue&type=script&lang=js&"
import style0 from "./MatchResultModal.vue?vue&type=style&index=0&id=34194078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34194078",
  null
  
)

export default component.exports